export enum DefinitionOrderTemperatureControl {
  'Room Temp 15-25°C' = 'AMB',
  'Cold Temp 2-8°C' = 'Chiller',
  'Freezing -20°C' = 'Frozen',
  'Deep Freeze -65 to -80' = 'DeepFrozen',
  'AMB' = 'AMB',
  'Chiller' = 'Chiller',
  'Frozen' = 'Frozen',
  'Deep_Frozen' = 'DeepFrozen',
}
